import * as _ from "lodash";

export class Media {
    static Instagram = new Media("Instagram", "rgb(153, 69, 181)");
    static Facebook  = new Media("Facebook",  "rgb(59, 89, 153)");
    static Twitter   = new Media("Twitter",   "rgb(85, 172, 239)");
    static YouTube   = new Media("YouTube",   "rgb(206, 32, 31)");
    static AllMedias = [Media.Instagram, Media.Facebook, Media.Twitter, Media.YouTube];

    static mediaWithName(name: string): Media {
        return _.find(Media.AllMedias, it => it.name == name) || new Media(name, "magenta");
    }

    private constructor(public name: string, public color: string) {
    }

    get iconPath(): string {
        return `assets/app/images/icon-${this.name}.png`;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/model/media.ts